import React, { useEffect, useState } from "react";

import { ProgressIndicator } from "@veneer/core";
import './loader.css';

function Loader(props: any) {
    const [progress, setProgress] = useState(true);

    useEffect(() => {

    });

    return (
        <div className="loader-overlay">
            {progress ?
                <div className="progress-bar">
                    <ProgressIndicator
                        appearance="circular"
                        behavior="indeterminate"
                        size="medium"
                    />
                </div>
                :
                ""
            }
        </div>
    );
}

export default Loader;
